export const sliceNames = {
  PRODUCTS: 'products',
}
